import React, { useEffect } from 'react';

const ConsoleTest = () => {
  useEffect(() => {
    // These should be removed in production
    console.log('This is a regular log');
    console.debug('This is a debug log');
    console.info('This is an info log');
    
    // These should be preserved in production
    console.warn('This is a warning log');
    console.error('This is an error log');
  }, []);

  return (
    <div>
      <h2>Console Test Component</h2>
      <p>Check the browser console to see which logs appear</p>
    </div>
  );
};

export default ConsoleTest;
